export default {
  state: {
    userLoggedIn: false,
    targetPage: null
  },
  mutations: {
    SET_USER_LOGGED_IN: (state, payload) => {
      state.userLoggedIn = typeof payload === 'boolean' ? payload : localStorage.getItem('access_token') !== null
    },
    SET_TARGET_PAGE: (state, payload) => {
      if (payload) {
        localStorage.setItem('target_page', btoa(payload))
        state.targetPage = payload
      } else {
        let target = localStorage.getItem('target_page')
        if (target) {
          state.targetPage = atob(target)
        } else if (localStorage.getItem('access_token') !== null) {
          state.targetPage = 'ANY'
          localStorage.setItem('target_page', btoa('ANY'))
        }
      }
    }
  },
  getters: {
    isUserLoggedIn: state => {
      return state.userLoggedIn
    },
    getterTargetPage: state => {
      return state.targetPage
    }
  }
}
